import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-stocktwits', 'IconBrandStocktwits', [
  ['path', { d: 'M16 3l-8 4.5l8 4.5', key: 'svg-0' }],
  ['path', { d: 'M8 12l8 4.5l-8 4.5', key: 'svg-1' }],
]);
